var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Test Headline")]),_c('ul',{staticClass:"w-80"},_vm._l((_vm.tasks),function(task){return _c('li',{key:task.id},[_c('pre',[_vm._v(" "+_vm._s(task)+" ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }